import { Box, Button, FormControlLabel, FormGroup, IconButton, InputAdornment, Popper, TextField } from '@mui/material';
import CheckBox from '@root/components/v2/ui-elements/CheckBox';
import { X, ChevronDown } from 'lucide-react';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import './filter.scss';
import ResetButton from './ResetButton';
import { useTheme } from '@root/context/ThemeContext';

import noMfaLogo from '@root/assets/svg/Risk/RiskPriority/no-mfa.svg';
import AWSServiceIcons from '@root/components/awsServiceIcons';
import ComplianceIconMapping from '@root/components/complianceIconMapping';
import anomalousLogo from '@root/assets/svg/Risk/RiskPriority/anomalous.svg';
import dataLogo from '@root/assets/svg/Cloud_Events/data-security-logo.svg';
import dataAccessLogo from '@root/assets/svg/Risk/RiskPriority/data-access.svg';
import encryptionLogo from '@root/assets/svg/Cloud_Events/encryption-logo.svg';
import exposedSecretsLogo from '@root/assets/svg/Cloud_Events/exposed-secret.svg';
import highAvailabilityLogo from '@root/assets/svg/Cloud_Events/high-availability.svg';
import identityLogo from '@root/assets/svg/Cloud_Events/identity-logo.svg';
import lateralMovementLogo from '@root/assets/svg/Risk/RiskPriority/lateral-movement.svg';
import loggingMonitoringLogo from '@root/assets/svg/Cloud_Events/logging-and-monitoring.svg';
import networkLogo from '@root/assets/svg/Cloud_Events/network-logo.svg';
import noRiskLogo from '@root/assets/svg/Cloud_Events/no-risk-logo.svg';
import threatLogo from '@root/assets/svg/Risk/RiskPriority/threat.svg';
import userLogo from '@root/assets/svg/Cloud_Events/user-logo.svg';
import vulnerabilitiesLogo from '@root/assets/svg/Cloud_Events/vulnerabilities-logo.svg';
import administratorLogo from '@root/assets/svg/Risk/RiskPriority/admin.svg';
import credentialExposureLogo from '@root/assets/svg/Risk/RiskPriority/credential-exposure.svg';
import inactiveLogo from '@root/assets/svg/Risk/RiskPriority/inactive.png';
import infrastructureModificationLogo from '@root/assets/svg/Risk/RiskPriority/infrastructure-modification.svg';
import misconfigurationIcon from '@root/assets/svg/Cloud_Events/misconfigurationlogo.svg';
import overPrivilegedLogo from '@root/assets/svg/Risk/RiskPriority/over-privileged.svg';
import privilegeEscalationLogo from '@root/assets/svg/Risk/RiskPriority/privilege-escalation.svg';
import priviledgeLogo from '@root/assets/svg/Risk/RiskPriority/privledge.png';
import reconnaissanceLogo from '@root/assets/svg/Risk/RiskPriority/reconnaissance.svg';
import Malware from '@root/assets/svg/Cloud_Events/malware.svg';
import RuntimeLogo from '@root/assets/svg/Cloud_Events/runtimelogo.svg';
// import EffectiveAdmin from '@assets/svg/identity_risk_icons/effective_admin Hover.svg';
import EffectiveAdmin from '@root/assets/svg/Risk/RiskPriority/effective-admin.png';
import athena from '@root/assets/img/aws_services/aws_athena.svg';
import ComputeIcon from '@root/assets/svg/Service_Category_Icons/Compute.svg';
import ContainersIcon from '@root/assets/svg/Service_Category_Icons/Containers.svg';
import Analytics from '@root/assets/svg/Service_Category_Icons/Data_Analytics.svg';
import Database from '@root/assets/svg/Service_Category_Icons/Database.svg';
import DeveloperIcon from '@root/assets/svg/Service_Category_Icons/Developer_Tools.svg';
import MachineLearningIcon from '@root/assets/svg/Service_Category_Icons/Machine_Learning.svg';
import ManagementToolsIcon from '@root/assets/svg/Service_Category_Icons/Management_Tools.svg';
import NetworkingIcon from '@root/assets/svg/Service_Category_Icons/Networking.svg';
import ArtificialIntelligenceIcon from '@root/assets/svg/Top Services Categories/Artificial_Intelligence.svg';
import OperationIcon from '@root/assets/svg/Service_Category_Icons/Operations.svg';
import SecurityIdentityIcon from '@root/assets/svg/Service_Category_Icons/Security_Identity.svg';
import ServerlessIcon from '@root/assets/svg/Service_Category_Icons/Serverless.svg';
import StorageIcon from '@root/assets/svg/Service_Category_Icons/Storage.svg';

import multipleAccessKeysActiveLogo from '@root/assets/svg/Risk/RiskPriority/multiple-access-keys-active.png';
import crossAccountLogo from '@root/assets/svg/Risk/RiskPriority/cross-account.svg';
import environmentAccessLogo from '@root/assets/svg/Risk/RiskPriority/environment-access.svg';
import rootUserLogo from '@root/assets/svg/Risk/RiskPriority/root-user.svg';
import accessKey1NotRotatedLogo from '@root/assets/svg/Risk/RiskPriority/access-key1-not-rotated.svg';
import permissionManagementLogo from '@root/assets/svg/Risk/RiskPriority/permission-management.png';
import accessKey2NotRotatedLogo from '@root/assets/svg/Risk/RiskPriority/access-key2-not-rotated.svg';
import attackPathLogo from '@root/assets/svg/Risk/RiskPriority/attack_path.svg';
import credentialAccessIcon from '@root/assets/svg/Cloud_Events/credential_access.png';
import learningLogo from '@root/assets/svg/Risk/RiskPriority/learning.svg';
import environmentIsolationLogo from '@root/assets/svg/Cloud_Events/environment-isolation.svg';
import infrastructureSecurityLogo from '@root/assets/svg/Cloud_Events/infrastructure-security.svg';
import inventoryManagementLogo from '@root/assets/svg/Cloud_Events/inventory-management.svg';
import resourceManagementLogo from '@root/assets/svg/Cloud_Events/resource-management.svg';
import rateLimitingLogo from '@root/assets/svg/Cloud_Events/rate-limiting.svg';
import workloadSecurityLogo from '@root/assets/svg/Cloud_Events/workload-security-logo.svg';
import thirdPartyLogo from '@root/assets/svg/Cloud_Events/third-party-logo.svg';
import availabilityOperationsLogo from '@root/assets/svg/Cloud_Events/availability-operations.svg';
import identityAccessLogo from '@root/assets/svg/Cloud_Events/identity-access.svg';
import supplyChainLogo from '@root/assets/svg/Cloud_Events/supply-chain.svg';
import vulnerabilityManagementLogo from '@root/assets/svg/Cloud_Events/vulnerability-management.svg';
import workloadHardeningLogo from '@root/assets/svg/Cloud_Events/workload-hardening.svg';
import governanceHygieneLogo from '@root/assets/svg/Cloud_Events/governance-hygiene.svg';
import authenticationLogo from '@root/assets/svg/Cloud_Events/authentication.svg';
import inputValidationLogo from '@root/assets/svg/Cloud_Events/input-validation.svg';
import documentationLogo from '@root/assets/svg/Cloud_Events/documentation.svg';
import attackPreventionLogo from '@root/assets/svg/Cloud_Events/attack-prevention.svg';
import informationDisclosureLogo from '@root/assets/svg/Cloud_Events/information-disclosure.svg';
import complianceLogo from '@root/assets/svg/Cloud_Events/compliance.svg';
import privacyLogo from '@root/assets/svg/Cloud_Events/privacy.svg';
import lifecycleManagementLogo from '@root/assets/svg/Cloud_Events/lifecycle-management.svg';
import riskAssessmentLogo from '@root/assets/svg/Cloud_Events/risk-assessment.svg';
import operationsLogo from '@root/assets/svg/Risk/RiskPriority/operations.svg';
import iaCLogo from '@root/assets/svg/Risk/Risks Icons/iac_misconfig.svg';
import dangerousPermissionLogo from '@root/assets/svg/Risk/RiskPriority/dangerous_permissions.png';
import networkExposure from '@root/assets/svg/Cloud_Events/network-exposure.svg';
import backupRecovery from '@root/assets/svg/Cloud_Events/backup-recovery.svg';
import monitoring from '@root/assets/svg/Cloud_Events/monitoring.svg';
import auditingMonitoring from '@root/assets/svg/Cloud_Events/auditing-monitoring.svg';
import authAccessControl from '@root/assets/svg/Cloud_Events/auth-access-control.svg';
import dataProtection from '@root/assets/svg/Cloud_Events/data-protection.svg';
import clusterConfiguration from '@root/assets/svg/Cloud_Events/cluster-configuration.svg';
import dataQuality from '@root/assets/svg/Cloud_Events/data-quality.svg';
import performance from '@root/assets/svg/Cloud_Events/performance.svg';
import cost from '@root/assets/svg/Cloud_Events/cost.svg';
import leastPrivilege from '@root/assets/svg/Cloud_Events/least-privilege.svg';
import SastLogo from '@root/assets/svg/Risk/RiskPriority/SAST.svg';
import ScaLogo from '@root/assets/svg/Risk/RiskPriority/SCA.svg';
import ContainerLogo from '@root/assets/svg/Risk/RiskPriority/container.svg';
import ApiLogo from '@root/assets/svg/Risk/RiskPriority/API.svg';
// import permission_management from '@assets/svg/identity_risk_icons/permission_management Hover.svg';
import { isBoolean, isEmpty } from 'lodash';

import Tooltip from '../v2/ui-elements/Tooltip';
import RegionsFlagIcons from '../v2/ui-elements/CountryFlagIcons/regionFlagIcons';
import NoData from '../common/NoData';
import SearchIcon from '@root/assets/svg/Navigation/SearchIcon';

const active_risk_mapping = {
  ['Data']: dataLogo,
  ['Credential Exposure']: credentialExposureLogo,
  ['Data Exposure']: dataLogo,

  ['Privilege Escalation']: privilegeEscalationLogo,
  ['Reconnaissance']: reconnaissanceLogo,
  ['Privileged']: priviledgeLogo,
  ['Inactive']: inactiveLogo,
  ['Threat']: threatLogo,
  ['Administrator']: administratorLogo,
  ['Admin']: administratorLogo,
  ['Infrastructure Modification']: infrastructureModificationLogo,
  ['Over Privileged']: overPrivilegedLogo,
  ['Data Security']: dataLogo,
  ['Encryption']: encryptionLogo,
  ['Exposed Secrets']: exposedSecretsLogo,
  ['Network']: networkLogo,
  ['Network Security']: networkLogo,

  ['Anomalous']: anomalousLogo,
  ['Logging And Monitoring']: loggingMonitoringLogo,
  ['Logging & Monitoring']: loggingMonitoringLogo,
  ['Lateral Movement']: lateralMovementLogo,
  ['High Availability']: highAvailabilityLogo,
  ['Identity']: identityLogo,
  ['IAM']: identityLogo,
  ['User']: userLogo,
  ['Vulnerabilities']: vulnerabilitiesLogo,
  ['NoRisk']: noRiskLogo,
  ['Misconfiguration']: misconfigurationIcon,
  ['Configuration']: misconfigurationIcon,
  ['Security Misconfiguration']: misconfigurationIcon,

  ['Malware']: Malware,
  ['Runtime']: RuntimeLogo,
  ['Runtime Behavior']: RuntimeLogo,
  ['No Mfa']: noMfaLogo,
  ['Cross Account']: crossAccountLogo,
  ['Environment Access']: environmentAccessLogo,
  ['Multiple Access Keys Active']: multipleAccessKeysActiveLogo,
  ['Root User']: rootUserLogo,
  ['Access Key 1 Not Rotated']: accessKey1NotRotatedLogo,
  ['Learning']: learningLogo,
  ['Access Key 2 Not Rotated']: accessKey2NotRotatedLogo,
  ['Attack path']: attackPathLogo,
  ['Attack Path']: attackPathLogo,
  ['Attack paths']: attackPathLogo,
  ['Credential Access']: credentialAccessIcon,
  ['Access Control']: credentialAccessIcon,
  ['Access control']: credentialAccessIcon,

  ['Environment Isolation']: environmentIsolationLogo,
  ['Infrastructure Security']: infrastructureSecurityLogo,
  ['Inventory Management']: inventoryManagementLogo,
  ['Resource Management']: resourceManagementLogo,
  ['Rate Limiting']: rateLimitingLogo,
  ['Authentication']: authenticationLogo,
  ['Input Validation']: inputValidationLogo,
  ['Documentation']: documentationLogo,
  ['Attack Prevention']: attackPreventionLogo,
  ['Information Disclosure']: informationDisclosureLogo,
  ['Compliance']: complianceLogo,
  ['Privacy']: privacyLogo,
  ['Lifecycle Management']: lifecycleManagementLogo,
  ['Risk Assessment']: riskAssessmentLogo,
  ['Network exposure']: networkExposure,
  ['Backup & recovery']: backupRecovery,
  ['Monitoring']: monitoring,
  ['Auditing Monitoring']: auditingMonitoring,
  ['Auditing & Monitoring']: auditingMonitoring,
  ['Data protection']: dataProtection,
  ['Remote Code Execution']: dataProtection,
  ['Authentication & Access Control']: authAccessControl,
  ['Cluster Configuration']: clusterConfiguration,
  ['Data Quality']: dataQuality,
  ['Performance']: performance,
  ['Cost']: cost,
  ['Least Privilege']: leastPrivilege,

  // Kubernetes Risk Temp
  ['Effective Admin']: EffectiveAdmin,
  ['Data Access']: dataAccessLogo,
  ['High Privileged']: overPrivilegedLogo,
  ['Availability']: highAvailabilityLogo,
  ['Vulnerability']: vulnerabilitiesLogo,
  ['Operational']: operationsLogo,
  ['IaC']: iaCLogo,
  ['Anomaly Detection']: threatLogo,
  ['Dangerous permission']: dangerousPermissionLogo,
  ['Internet Exposed']: exposedSecretsLogo,

  ['Misconfigurations']: misconfigurationIcon,
  ['Threats anomaly']: threatLogo,
  ['Anomaly']: anomalousLogo,
  ['Permission Management']: permissionManagementLogo,
  ['Workload Security']: workloadSecurityLogo,
  ['Third Party']: thirdPartyLogo,
  ['Availability & Operations']: availabilityOperationsLogo,
  ['Availability And Operations']: availabilityOperationsLogo,
  ['Identity & Access']: identityAccessLogo,
  ['Identity And Access']: identityAccessLogo,
  ['Supply Chain']: supplyChainLogo,
  ['Vulnerability Management']: vulnerabilityManagementLogo,
  ['Workload Hardening']: workloadHardeningLogo,
  ['Governance & Hygiene']: governanceHygieneLogo,
  ['Governance And Hygiene']: governanceHygieneLogo,

  // Checkmarx
  ['SAST']: SastLogo,
  ['SCA']: ScaLogo,
  ['Container']: ContainerLogo,
  ['API']: ApiLogo,
};

const serviceGridIcons = {
  [`Networking`]: NetworkingIcon,
  ['Artificial Intelligence']: ArtificialIntelligenceIcon,
  ['Operations']: OperationIcon,
  ['Developer Tools']: DeveloperIcon,
  ['Machine Learning']: MachineLearningIcon,
  ['Storage']: StorageIcon,
  ['Compute']: ComputeIcon,
  ['Security & Identity']: SecurityIdentityIcon,
  ['Serverless']: ServerlessIcon,
  ['Management Tools']: ManagementToolsIcon,
  ['Containers']: ContainersIcon,
  ['Data Analytics']: Analytics,
  ['Database']: Database,
  ['Athena']: athena,
};

const FilterComponent = ({
  openFilter,
  option,
  selectedFilters,
  setSelectedFilters,
  defaultValue,
  setIsDefaultValue,
  setInventoryTableBreadcrumb,
  zIndex = 1300,
  disablePortal = false,
}) => {
  const { isDarkMode } = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const buttonRefs = useRef([]);
  const popperRefs = useRef([]);
  const [openFilterId, setOpenFilterId] = useState(null);
  const [isAnyPopperOpen, setIsAnyPopperOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const filterOptions = useMemo(() => {
    if (option)
      return Object.keys(option)?.map(key => ({
        id: key.toLowerCase().replace(/\s+/g, '_'),
        label: key,
        options: option[key],
      }));
  }, [option]);

  const handleFilterClick = (event, filterId) => {
    setAnchorEl(event.currentTarget);
    setOpenFilterId(filterId);

    setIsAnyPopperOpen(prev => {
      if (!openFilterId) {
        // initially if no filter is open
        return true;
      } else if (prev && openFilterId === filterId) {
        // 2rd case if user clicks on the same filter => then it should be closed
        return false;
      } else if (prev && openFilterId !== filterId) {
        // 3nd case if one property is open and the user switches to another property
        //  => From risk -> cq-shield-priority
        // popper will remain open
        return true;
        // else reverse
      } else return !prev;
    });
    setSearchTerm(''); // Reset search term when opening a new filter
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpenFilterId(null);
    setSearchTerm(''); // Reset search term when closing
  };
  const handleClearSearch = event => {
    event.stopPropagation();
    setSearchTerm('');
  };

  const handleSearchChange = event => {
    setSearchTerm(event.target.value);
  };

  const handleFilterChange = (filterId, option, isChecked, e) => {
    if (e) {
      e.stopPropagation();
    }
    setSelectedFilters(prev => {
      const updatedFilter = { ...prev };
      if (isChecked) {
        updatedFilter[filterId] = [...(updatedFilter[filterId] || []), option];
      } else {
        updatedFilter[filterId] = (updatedFilter[filterId] || []).filter(item => item !== option);
      }
      if (updatedFilter[filterId]?.length === 0) {
        if (Array.isArray(updatedFilter[filterId])) {
          updatedFilter[filterId] = [];
        } else {
          updatedFilter[filterId] = '';
        }
      }
      return updatedFilter;
    });
    // only removing services breadcrumb independently of any prefixed breadcrumb
    if (filterId?.toLowerCase() === 'services') {
      setInventoryTableBreadcrumb(prev => {
        return prev.filter(
          item => !(item.title?.toLowerCase().includes('aws') || item.title?.toLowerCase().includes('gcp')),
        );
      });
    }
  };

  const getFilteredOptions = options => {
    return options.filter(option => String(option).toLowerCase().includes(searchTerm.toLowerCase()));
  };

  useEffect(() => {
    if (!isEmpty(defaultValue)) {
      const initialFilters = {};
      Object.entries(defaultValue || {})?.map(([key, value]) => {
        initialFilters[key] = value;
      });
      setSelectedFilters(prev => ({ ...prev, ...initialFilters }));
      if (setIsDefaultValue) setIsDefaultValue(true);
    }
  }, [defaultValue, setIsDefaultValue, setSelectedFilters]);

  const clearFilter = (filterId, e) => {
    if (e) {
      e.stopPropagation();
    }
    setSelectedFilters(prev => {
      const updatedFilter = { ...prev };
      if (Array.isArray(updatedFilter[filterId])) {
        updatedFilter[filterId] = [];
      } else {
        updatedFilter[filterId] = '';
      }
      return updatedFilter;
    });
  };

  useEffect(() => {
    const handleClickOutside = event => {
      // Skip processing if no poppers are open
      if (!isAnyPopperOpen) return;

      let isClickOutside = true;

      // Loop through each button and check if the click was outside any button or its popper
      for (let i = 0; i < buttonRefs.current.length; i++) {
        if (buttonRefs.current[i]?.contains(event.target) || popperRefs.current[i]?.contains(event.target)) {
          isClickOutside = false; // The click is inside one of the buttons or poppers
          break;
        }
      }

      if (isClickOutside) {
        setIsAnyPopperOpen(false); // Close all poppers if the click was outside
        setOpenFilterId(null); // Clear the open filter ID when closing
      }
    };

    // Use mousedown instead of click for better reliability
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup the event listener when the component is unmounted
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isAnyPopperOpen]); // Add isAnyPopperOpen to dependencies to avoid unnecessary checks

  const resetAllFilters = () => {
    const emptyFilters = {};
    Object.keys(selectedFilters).forEach(key => {
      emptyFilters[key] = Array.isArray(selectedFilters[key]) ? [] : '';
    });
    setSelectedFilters(emptyFilters);
  };
  const hasActiveFilters = Object.values(selectedFilters).some(filter =>
    Array.isArray(filter) ? filter.length > 0 : Boolean(filter),
  );
  if (!openFilter) return <></>;

  return (
    <div className="filter-component">
      <div className="filter-buttons">
        {filterOptions?.map((filter, index) => (
          <React.Fragment key={filter.id}>
            <Button
              variant="outlined"
              ref={el => (buttonRefs.current[index] = el)}
              onClick={e => handleFilterClick(e, filter.id)}
              className="filter-button"
              style={{
                borderColor:
                  selectedFilters[filter.id]?.length > 0
                    ? isDarkMode
                      ? '#4299e1'
                      : 'rgb(1,64,227)'
                    : isDarkMode
                    ? '#4a5568'
                    : 'var(--border-color-light)',
              }}>
              {filter.label}
              {selectedFilters[filter.id]?.length > 0 && (
                <span className=""> : ({selectedFilters[filter.id].length})</span>
              )}
              <ChevronDown
                size={16}
                style={{
                  transform: isAnyPopperOpen && openFilterId === filter.id ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.2s ease-in-out',
                  color: 'rgb(34, 34, 34)',
                }}
              />
            </Button>
            <Popper
              disablePortal={disablePortal}
              open={isAnyPopperOpen && openFilterId === filter.id}
              sx={{
                backgroundColor: isDarkMode ? '#1a202c' : '#ffffff',
                color: isDarkMode ? '#e2e8f0' : '#1a202c',
                border: `1px solid ${isDarkMode ? '#2d3748' : 'var(--border-color-light)'}`,
                boxShadow: isDarkMode
                  ? '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.2),2px 3px 14px 2px rgba(0,0,0,0.2)'
                  : '0px 5px 5px -3px rgba(0,0,0,0.05),0px 8px 10px 1px rgba(0,0,0,0.05),2px 3px 14px 2px rgba(0,0,0,0.05)',
                borderRadius: '10px',
                overflow: 'hidden',
                zIndex: `${zIndex} !important`,
                marginTop: '7px !important',
                // transition: 'all 0.3s ease',
              }}
              anchorEl={anchorEl}
              onClose={handleClose}
              ref={el => (popperRefs.current[index] = el)}
              className="CustomScrollbar"
              placement="bottom-start"

              // anchorOrigin={{
              //   vertical: 'bottom',
              //   horizontal: 'left',
              // }}
            >
              <div style={{ padding: '10px 10px 0 10px' }}>
                <TextField
                  size="small"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={handleSearchChange}
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ fontSize: '18px', color: 'rgba(0, 0, 0, 0.54)' }} />
                      </InputAdornment>
                    ),
                    endAdornment: searchTerm && (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="clear search"
                          onClick={handleClearSearch}
                          edge="end"
                          size="small"
                          sx={{
                            padding: '2px',
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            },
                          }}>
                          <X size={16} style={{ color: 'rgba(0, 0, 0, 0.54)' }} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: '13px',
                      fontFamily: 'Manrope',
                      color: isDarkMode ? '#e2e8f0' : 'inherit',
                      '& fieldset': {
                        border: 'none',
                      },
                    },
                    '& .MuiOutlinedInput-input': {
                      padding: '8px 0px',
                    },
                    backgroundColor: isDarkMode ? '#2d3748' : 'rgb(249, 250, 251)',
                    borderRadius: '5px',
                    // transition: 'all 0.3s ease',
                  }}
                />
              </div>
              <div
                className="filter-popover CustomScrollbar"
                style={{
                  marginTop: '10px',
                  maxHeight: '226px',
                  minWidth: '100px',
                  overflowY: 'auto',
                  maxWidth: '450px',
                }}>
                <FormGroup>
                  {getFilteredOptions(filter?.options || []).length === 0 ? (
                    <div style={{ padding: '10px 20px' }}>
                      <NoData height="100px" />
                    </div>
                  ) : (
                    getFilteredOptions(filter?.options || []).map(option => (
                      <FormControlLabel
                        className="CustomScrollbar"
                        sx={{
                          marginBottom: '0px',
                          marginRight: '0px',
                          padding: '0px 20px',
                          display: 'flex !important',
                          flexWrap: 'nowrap',
                          '.MuiTypography-root': {
                            fontFamily: 'Manrope',
                            fontSize: '13px',
                            fontWeight: '500',
                          },
                          '&:hover': {
                            backgroundColor: 'rgb(238,238,238)',
                          },
                          '&:active': {
                            backgroundColor: 'rgb(238,238,238)',
                          },
                        }}
                        key={option}
                        control={
                          <CheckBox
                            checked={
                              selectedFilters[filter.id]?.includes(option) ||
                              (!isBoolean(option) && selectedFilters[filter.id]?.includes(option)) ||
                              false
                            }
                            onClick={e => e.stopPropagation()}
                            onChange={e => handleFilterChange(filter.id, option, e.target.checked, e)}
                          />
                        }
                        onClick={e => e.stopPropagation()}
                        label={
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            {active_risk_mapping[option] && filter.label?.toUpperCase()?.includes('RISK') && (
                              <img
                                src={active_risk_mapping[option]}
                                style={{ marginRight: '7px', width: '18px', height: '18px' }}
                              />
                            )}
                            {filter.label === 'Compliance Family' && (
                              <ComplianceIconMapping
                                name={option}
                                width="20px"
                                height="20px"
                                style={{ marginRight: '5px' }}
                              />
                            )}
                            {/* Services filters already get the AWSServiceIcons icon below */}
                            {serviceGridIcons[option] && filter.label !== 'Services' && filter.label !== 'Service' && (
                              <img
                                src={serviceGridIcons[option]}
                                style={{ marginRight: '5px', width: '20px', height: '20px' }}
                              />
                            )}
                            {(filter.label === 'Services' || filter.label === 'Service') && (
                              <div style={{ marginRight: '10px' }}>
                                <AWSServiceIcons name={option} imgWidth={13} imgHeight={13} />
                              </div>
                            )}
                            {(filter.label === 'Regions' || filter.label === 'Region') && (
                              <div style={{ marginRight: '10px' }}>
                                <RegionsFlagIcons name={option} isRounded={true} />
                              </div>
                            )}
                            <Tooltip title={option}>
                              <span
                                className="SingleLine"
                                style={{
                                  fontSize: '13px',
                                  fontFamily: 'Manrope',
                                  fontWeight: '500',
                                  maxWidth: '350px',
                                }}>
                                {typeof option === 'boolean' ? option.toString() : option}
                              </span>
                            </Tooltip>
                          </div>
                        }
                      />
                    ))
                  )}
                </FormGroup>
              </div>
              <Box display={'flex'} justifyContent={'center'} margin={'7px'}>
                <Button
                  onClick={e => {
                    clearFilter(filter.id, e);
                  }}
                  className="clear-button"
                  sx={{
                    textTransform: 'none',
                    fontSize: '12px',
                    fontFamily: 'Manrope',
                    fontWeight: '500',
                    color: 'rgb(24, 95, 226)',
                    padding: '3px 8px',
                    borderRadius: '5px',
                  }}>
                  Clear
                </Button>
              </Box>
            </Popper>
          </React.Fragment>
        ))}
        {hasActiveFilters && <ResetButton onClick={resetAllFilters} />}
      </div>
    </div>
  );
};

export default FilterComponent;
